<template>
    <div v-if="isMounted">
        <vue-scroll>
            <div :style="{'height':500+'px'}">
                <div class="card-body">
                    <el-form ref="form" :label-position="'center'"
                             label-width="90px">
                        <div class="m-portlet">
                            <div class="card-body">
                                <el-row :gutter="20">
                                    <el-col :span="20">
                                        <el-row :gutter="20">
                                            <!--学校选择-->
                                            <el-col :span="20">
                                                <el-form-item
                                                        v-if="$parentInfo.schoolExamList.createSchoolExam.school_status"
                                                        label="学校" prop="school">
                                                    <el-select
                                                            v-model="$parentInfo.schoolExamList.createSchoolExam.outlineForm.school_id"
                                                            filterable remote :remote-method="handleSearchSchool"
                                                            placeholder="关键字搜索学校">
                                                        <el-option
                                                                v-for="item in $parentInfo.schoolExamList.filter.schools"
                                                                :key="item.id"
                                                                :label="item.name"
                                                                :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                    <el-button @click="handleSchoolInputChange()" size="mini">+
                                                    </el-button>
                                                </el-form-item>
                                                <el-form-item v-else label="学校">
                                                    <el-input style="width:215px"
                                                              v-model="$parentInfo.schoolExamList.createSchoolExam.outlineForm.newSchool_name"
                                                              placeholder="输入学校"
                                                    ></el-input>
                                                    <el-button @click="handleSchoolInputChange()">-</el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <!--考试名称-->
                                            <el-col :span="10">
                                                <el-form-item label="考试名称">
                                                    <el-input
                                                            type="text"
                                                            :rows="3"
                                                            placeholder="考试名称"
                                                            v-model="$parentInfo.schoolExamList.createSchoolExam.outlineForm.exam_name">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>

                                            <!--考试时间-->
                                            <el-col :span="10">
                                                <el-form-item label="考试时间">
                                                    <el-date-picker
                                                            v-model="$parentInfo.schoolExamList.createSchoolExam.outlineForm.examDate"
                                                            type="date"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="选择日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">

                                            <!--年级-->
                                            <el-col :span="10">
                                                <el-form-item label="年级">
                                                    <el-select
                                                            v-model="$parentInfo.schoolExamList.createSchoolExam.outlineForm.grade_id"
                                                            filterable
                                                            placeholder="请选择年级">
                                                        <el-option
                                                                v-for="item in $parentInfo.schoolExamList.filter.grades"
                                                                :key="item.id"
                                                                :label="item.name"
                                                                :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>

                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-form-item
                                                    v-for="(subject, index) in $parentInfo.schoolExamList.createSchoolExam.outlineForm.subjects"
                                                    label=""
                                                    label-width="0">
                                                <el-col :span="6">
                                                    <el-form-item label="学科">
                                                        <el-select v-model="subject.id" placeholder="学科">
                                                            <el-option
                                                                    v-for="item in $parentInfo.schoolExamList.filter.subjects"
                                                                    :key="item.id"
                                                                    :label="item.name"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-form-item label="学科总分">
                                                        <el-input v-model="subject.totalScore"
                                                                  placeholder=""></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-form-item label="年级平均分">
                                                        <el-input v-model="subject.gradeAvgScore"
                                                                  placeholder=""></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-form-item label="区平均分">
                                                        <el-input v-model="subject.areaAvgScore"
                                                                  placeholder=""></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="2" align="center">
                                                    <el-form-item v-if="index===0">
                                                        <el-button @click="handleAddSubject()">新增学科</el-button>
                                                    </el-form-item>
                                                    <el-form-item v-else>
                                                        <el-button @click="handleRemoveSubject(subject)">X</el-button>
                                                    </el-form-item>
                                                </el-col>
                                            </el-form-item>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div>
                    <el-button v-if="$parentInfo.powers.includes(33)" type="primary"
                               @click="handleAddSchoolExam()"
                               :loading="$parentInfo.schoolExamList.createSchoolExam.button_loading">新建
                    </el-button>
                </div>
            </div>

        </vue-scroll>

    </div>
</template>

<script>
    export default {
        name: 'create-schoolExam',
        data() {
            return {
                isMounted: false
            }
        },
        computed: {
            // clientWidth() {
            //     if (this.$store.state.config.clientWidth >= 1750) {
            //         return 12;
            //     } else {
            //         return 24;
            //     }
            // },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {

        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.isMounted = true;
        },
        methods: {
            handleSchoolInputChange() {
                if (this.$parentInfo.schoolExamList.createSchoolExam.school_status === true) {
                    this.$parentInfo.schoolExamList.createSchoolExam.school_status = false;
                } else {
                    this.$parentInfo.schoolExamList.createSchoolExam.school_status = true;
                    this.$parentInfo.schoolExamList.createSchoolExam.outlineForm.newSchool_name = '';
                }
            },
            handleRemoveSubject(item) {
                let index = this.$parentInfo.schoolExamList.createSchoolExam.outlineForm.subjects.indexOf(item);
                if (index !== -1) {
                    this.$parentInfo.schoolExamList.createSchoolExam.outlineForm.subjects.splice(index, 1)
                }
            },
            handleAddSubject() {
                this.$parentInfo.schoolExamList.createSchoolExam.outlineForm.subjects.push({
                    id: '',
                    totalScore: '',
                    classAvgScore: '',
                    gradeAvgScore: '',
                    areaAvgScore: '',
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.$parentInfo.schoolExamList.path, 'search', {
                    'type': 'schoolKeyName',
                    'schoolKeyName': query,
                });
            },
            //添加学校考试
            handleAddSchoolExam() {
                this.$parentInfo.schoolExamList.createSchoolExam.button_loading = true;
                this.$parentInfo.schoolExamList.createSchoolExam.outlineForm.date = this.$moment(this.$parentInfo.schoolExamList.createSchoolExam.outlineForm.examDate).format('YYYY-MM-DD');
                this.$wApi.send(this.$parentInfo.schoolExamList.path, 'create_schoolExam', {
                    'form': this.$parentInfo.schoolExamList.createSchoolExam.outlineForm,
                });
            }
        }
    }
</script>

<style scoped>
    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>
